// extracted by mini-css-extract-plugin
module.exports = {"logoImage":"logo_logoImage__U6_kq","logoWrapper":"logo_logoWrapper__1qXg5"};